import ChartContainer from '../../../Common/Services/charts/apex-charts/ChartContainer';
import { useCompareValuesPerYearPerMonthPercentage } from './hooks/useCompareValuesPerYearPerMonthPercentage';

export const CompareValuesPerYearPerMonthPercentage = () => {
    const { chartConfig } = useCompareValuesPerYearPerMonthPercentage();
    
    return (
        <ChartContainer
            title={`Evolução do Índice de Eficácia entre o Valor Aprovado e o Valor Produzido`}
            options={chartConfig.options}
            series={chartConfig.series}
            type="bar"
            height={320}
        />
    );
};
